import { Box, Text, chakra } from '@chakra-ui/react';
import { Avatar } from '@/components/ui/avatar';
import type { RecipientOptionView } from './types';

interface RecipientContactRowProps {
  option: RecipientOptionView;
  onSelect: (id: string) => void;
}

/**
 * One selectable contact row: avatar, name, and the sub-label. An optional badge
 * trails the name (e.g. "active in N programs").
 */
export const RecipientContactRow = ({ option, onSelect }: RecipientContactRowProps) => (
  <chakra.button
    type="button"
    display="flex"
    alignItems="center"
    gap="10px"
    p="8px"
    rounded="10px"
    textAlign="left"
    w="full"
    _hover={{ bg: 'bg.muted' }}
    onClick={() => onSelect(option.id)}
  >
    <Avatar size="sm" src={option.avatarUrl ?? undefined} name={option.displayName} />
    <Box minW={0} flex="1">
      <Text fontSize="sm" fontWeight="medium" lineClamp={1}>
        {option.displayName}
      </Text>
      {option.subLabel && (
        <Text fontSize="xs" color="fg.muted" lineClamp={1}>
          {option.subLabel}
        </Text>
      )}
    </Box>
    {option.badge}
  </chakra.button>
);
